import React from 'react';

const MailAppContext = React.createContext({});

export default MailAppContext;
